/**
 * @name tree
 */
import base from '../../base';
import Tree from './tree';
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

Tree.install = function(Vue) {
  Vue.use(base);
  Vue.use(PerfectScrollbar)
  Vue.component(Tree.name, Tree);
};

export default Tree;